import jwtDecode from 'jwt-decode';

export const decodeToken = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    if (decoded?.sub && !decoded.userId) {
      return { ...decoded, userId: decoded.sub };
    }
    return decoded;
  } catch (error) {
    return null;
  }
};
